var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-by-cabin"},_vm._l((_vm.cabin_options),function(option,index){return _c('filters-button',{key:`${option}:cabin_options:${index}`,attrs:{"text":option.text,"active":_vm.cabin === option.value},on:{"click":() => _vm.handle_change(option.value)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }